import { Box } from '@mui/material';
import CustomButton from '@ui-components/Button/CustomButton';
import { useAuth } from '@auth/AuthProvider';

export default function AccessDenied() {
  const { logout } = useAuth();
  const handleOpeartionUserLogout = () => {
    localStorage.clear();
    logout();
  };
  return (
    <Box textAlign="center" mt={10}>
      <h2>Access Denied</h2>
      <p>
        You are not authorized to use this system. Please contact your
        administrator.
      </p>
      <Box className="mt-24">
        <CustomButton id="logout" onClick={() => handleOpeartionUserLogout()}>
          Logout
        </CustomButton>
      </Box>
    </Box>
  );
}
